import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";

export class vnAppZoneContent extends vnAppZone {

    protected factory: pageFactory;

    public constructor(destination, appInterface: string | null = null) {
        super(destination, appInterface);
        this.zoneName = "Content";

        this.isOnAlwaysReloadMode = true;
        this.factory = new pageFactory();
    }


    protected defineRoutes_getModule(moduleKey: string){
        let _mythis = this;
        return function(){
            // obtain the right module object
            let moduleObj = _mythis.factory.get_actionHandler(moduleKey, _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }
    }

    defineRoutes(appInterface) {
        let _mythis = this;

        //define routes

        this.addForRoute('/login', _mythis.defineRoutes_getModule("login"), null);
        this.addForRoute('/logs', _mythis.defineRoutes_getModule("logs"), _mythis.defineRoutes_getModule("login"));

        if (appInterface == 'dashboard') {

            this.addForRoute('/', _mythis.defineRoutes_getModule("accountDashboard"), _mythis.defineRoutes_getModule("login"));
        } else {

            this.addForRoute('/reset/accountName/:accountName/token/:token', _mythis.defineRoutes_getModule("reset_password"), null);

            this.addForRoute('/signup', _mythis.defineRoutes_getModule("signup"), null);
            this.addForRoute('/emailConfirmation/token/:token', _mythis.defineRoutes_getModule("email_confirmation"), null);

            this.addForRoute('/notification/optOut/:token', _mythis.defineRoutes_getModule("notification_optOut"), null );

            this.addForRoute('/', _mythis.defineRoutes_getModule("live_dashboard"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/account_settings', _mythis.defineRoutes_getModule("account_settings"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/account_settings/suspicious_rules', _mythis.defineRoutes_getModule("suspicious_rules"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/account_api', _mythis.defineRoutes_getModule("account_api"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/account_apiUsage', _mythis.defineRoutes_getModule("account_apiUsage"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/usage_stats', _mythis.defineRoutes_getModule("usage_stats"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/property_management', _mythis.defineRoutes_getModule("property_management"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/subscription_management', _mythis.defineRoutes_getModule("subscription_management"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/audience_overview', _mythis.defineRoutes_getModule("audience_overview"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/interaction_overview', _mythis.defineRoutes_getModule("interaction_overview"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/permalink_details', _mythis.defineRoutes_getModule("permalink_details"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/page_performance', _mythis.defineRoutes_getModule("permalink_search"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/google_insights', _mythis.defineRoutes_getModule("google_insights"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/brand_dashboard', _mythis.defineRoutes_getModule("brand_dashboard"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/human_bot_score', _mythis.defineRoutes_getModule("human_bot_score"), _mythis.defineRoutes_getModule("login"));

            this.addForRoute('/user/edit/:id', _mythis.defineRoutes_getModule("users_edit"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/user/profile/:id', _mythis.defineRoutes_getModule("users_profile"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/user/add', _mythis.defineRoutes_getModule("users_edit"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/users', _mythis.defineRoutes_getModule("users"), _mythis.defineRoutes_getModule("login"));

            this.addForRoute('/custom_dimensions', _mythis.defineRoutes_getModule("custom_dimensions"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/custom_events', _mythis.defineRoutes_getModule("custom_events"), _mythis.defineRoutes_getModule("login"));

            // Roles routes
            this.addForRoute('/roles/edit', _mythis.defineRoutes_getModule("roles_edit"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/roles/edit/:id', _mythis.defineRoutes_getModule("roles_edit"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/roles/view/:id', _mythis.defineRoutes_getModule("roles_view"), _mythis.defineRoutes_getModule("login"));
            this.addForRoute('/roles', _mythis.defineRoutes_getModule("roles"), _mythis.defineRoutes_getModule("login"));
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_content.ts